import React from "react";
import { Button } from "react-bootstrap";

export default function ListProduct({productList, handleProductRemove} : { productList: string[] , handleProductRemove: (arg0 : string) => void} ) {
    return (
        <ul className="form-items list-trigger-criteria">
            <ListRows productList={productList} handleProductRemove={handleProductRemove}/>
        </ul>
    );
};

function ListRows({productList, handleProductRemove} : { productList: string[], handleProductRemove: (arg0 : string) => void})
{
    if(!productList)
    {
        return (
            <></>
        );
    }
    const rows = productList.map(product =>{
        return(
            <li key={product}>
                <div className="reference">{product}</div>
                <div className="actions">
                    <Button onClick={() => {handleProductRemove(product)}} type="button" className="btn btn-secondary btn-delete" title="Supprimer ce critère">
                        <span className="icon"></span>
                        <span className="text">Supprimer</span>
                    </Button>
                </div>
            </li>
        );
    }
    );
    return (
        <>
            {rows}
        </>
    );
}



